import { AuthTokenModel } from './../../common/interfaces/global-interfaces';
import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { NotificationService } from '../../services/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserManagementService } from '../../services/user-management.service';
import { AccountTypeEnum } from '../../common/interfaces/global-interfaces';
import { StorageService } from '../../services/storage.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  hide = true;
  loading = false;
  private fb: FormBuilder = inject(FormBuilder);
  private authService: AuthService = inject(AuthService);
  private notificationService: NotificationService =
    inject(NotificationService);
  private router: Router = inject(Router);
  private uaaService: UserManagementService = inject(UserManagementService);
  private storageService = inject(StorageService);
  private dialog = inject(MatDialog);
  private route = inject(ActivatedRoute);
  private next: 'instant' | 'subscription' | null;
  redirectUri: string = "https://vc3.mikutano.co.tz/auth/login"
  clientId: string = "1002044198115-5a25ef55k5ed0ecg3rp3ja8ef75l8v15.apps.googleusercontent.com"
  googleSignInUrl: string = `https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=${this.redirectUri}&prompt=consent&response_type=code&client_id=${this.clientId}&scope=openid%20email%20profile&access_type=offline`;

  code: any;
  constructor(
  ) {}

  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      this.code = params['code'];
      if (this.code) {
        console.log('Authorization Code:', this.code);
        this.onGoogleSocialLogin(this.code)
      }
    });

    this.next = this.route.snapshot.queryParamMap.get('next') as
      | 'instant' | 'subscription'
      | null;

    this.form = this.fb.group({
      username: [null, Validators.required],
      password: [null, Validators.required],
    });
  }

  navigateTo(route: string[]) {
    this.router.navigate(route);
  }

  async login(formValue: any) {
    this.loading = true;
    try {
      const authTokenModel = await this.authService.login(formValue);

      if (authTokenModel?.access_token) {
        const user: any = await this.uaaService.getUserProfileAndRoles();

        if (user) {
          const accountType = user?.accountType;
          this.storageService.set('accountType', accountType);

          if (accountType === AccountTypeEnum.SYSTEM_ADMIN) {
            this.router.navigate(['super-admin']);
          } else if (this.next === 'instant') {
            this.router.navigate(['account', 'meetings-portal'], {
              queryParams: { page: 'new' },
            });
          } else if (this.next === 'subscription') {
            this.router.navigate(['account', 'manage-subscription', 'my-subscription']);
          } else {
            this.router.navigate(['account']);
          }

          this.notificationService.successMessage('Login successful!');
        } else {
          this.notificationService.errorMessage(
            'Login failed, please try again.'
          );
        }
      } else {
        this.notificationService.errorMessage('Incorrect Username or Password');
      }
    } catch (e: any) {
      this.notificationService.errorMessage('Login failed, please try again.');
    } finally {
      this.loading = false;
    }
  }

  async onGoogleSocialLogin(code: any) {
  this.loading = true;

  try {
    const tokenDetails = await this.authService.loginWithGoogle(code);

    if (tokenDetails?.accessToken) {
      const user = await this.uaaService.getUserProfileAndRoles();

      if (user) {
        const accountType = user.accountType;
        this.storageService.set('accountType', accountType);

        if (accountType === AccountTypeEnum.SYSTEM_ADMIN) {
            this.router.navigate(['super-admin']);
          } else if (this.next === 'instant') {
            this.router.navigate(['account', 'meetings-portal'], {
              queryParams: { page: 'new' },
            });
          } else if (this.next === 'subscription') {
            this.router.navigate(['account', 'manage-subscription', 'my-subscription']);
          } else {
            this.router.navigate(['account']);
          }

        this.notificationService.successMessage('Login successful!');
      }
    } else {
      this.notificationService.errorMessage('Login failed');
    }

  } catch (e: any) {
    this.notificationService.errorMessage(
      e?.message || 'Google login failed'
    );
  } finally {
    this.loading = false;
  }
}

}
